import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { DropDownSelectorValues } from 'providence-types';
import { HttpService } from '@core/services';
import { NotificationsHttpService } from '@core/services/http';
import { ModalMainTypes } from '@models/enums';
import { OptionProps, Schedule as ISchedule } from '@models/interfaces';
import { DeleteModal, VirtualTable } from '@shared/components';
import { PrimaryButton } from '@shared/modules';
import { DDVSelectors, NotificationSelectors } from '@store/selectors';
import { TowerOwnerFilter } from '../../components';
import { ScheduleModal } from './modals';
import { getScheduleTableColumns } from './models';

export const Schedule: FC = () => {
  const schedule = useSelector(NotificationSelectors.getSchedule);
  const paceTasksList = useSelector(NotificationSelectors.getPaceTasksList);
  const userList = useSelector(NotificationSelectors.getUserList);
  const towerOwnerDDV = useSelector(
    DDVSelectors.getDDVValuesByType(DropDownSelectorValues.TowerOwner),
  ) as OptionProps[];

  const [isAddEditModalVisible, setAddEditModalVisible] =
    useState<boolean>(false);
  const [currentModalType, setCurrentModalType] = useState<ModalMainTypes>(
    ModalMainTypes.Add,
  );
  const [modalValue, setModalValues] = useState<ISchedule | null>(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);

  const toggleAddAndEditModal = (
    type: ModalMainTypes,
    formValue?: ISchedule,
  ): void => {
    setCurrentModalType(type);
    setModalValues(formValue || null);
    setAddEditModalVisible(!isAddEditModalVisible);
  };

  const toggleDeleteModal = (formValue?: ISchedule): void => {
    setDeleteModalVisible(!deleteModalVisible);
    setModalValues(formValue || null);
  };

  const onDelete = async (): Promise<void> => {
    await HttpService.getHttpRequests(NotificationsHttpService).deleteSchedule(
      modalValue!._id,
    );

    toggleDeleteModal();
  };

  return (
    <div className="prov-notification">
      <div className="prov-notification__header-controls">
        <TowerOwnerFilter towerOwners={towerOwnerDDV} place="schedule" />
        <PrimaryButton
          title="Add Schedule"
          icon="+"
          onClick={(): void => toggleAddAndEditModal(ModalMainTypes.Add)}
        />
      </div>
      <VirtualTable
        dataSource={schedule}
        columns={getScheduleTableColumns(
          paceTasksList,
          userList,
          towerOwnerDDV,
          (scheduleRecord: ISchedule): void =>
            toggleAddAndEditModal(ModalMainTypes.Edit, scheduleRecord),
          (scheduleRecord: ISchedule): void =>
            toggleDeleteModal(scheduleRecord),
        )}
        maxViewRow={5}
        rowHeight={72}
        hasLongCellData
        verticalScrollCorrection={30}
      />
      <ScheduleModal
        visible={isAddEditModalVisible}
        modalType={currentModalType}
        toggleModal={toggleAddAndEditModal}
        itemValue={modalValue}
        paceTaskList={paceTasksList}
        userList={userList}
        towerOwners={towerOwnerDDV}
      />
      <DeleteModal
        visible={deleteModalVisible}
        onOk={onDelete}
        onCancel={(): void => toggleDeleteModal()}
      />
    </div>
  );
};
